import React, { Component } from "react";

import CookieHandler from "../../common/CookieHandler";
import config from "../../../config/config";
import api from "../../../api/api";
import {
  TextField,
  Snackbar,
  Switch,
  Typography,
  Grid,
  FormControlLabel,
  IconButton,
  InputAdornment,
  MenuItem,
} from "@material-ui/core";

import { Alert } from "@material-ui/lab";
import { withStyles } from "@material-ui/core/styles";
import DateFnsUtils from "@date-io/date-fns";
import FileUpload from "../../common/FileUpload";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import EventIcon from "@material-ui/icons/Event";
import Loader from "../../common/Loader";
const PurpleSwitch = withStyles({
  switchBase: {
    color: "#ccc",
    "&$checked": {
      color: config.themeColor,
    },
    "&$checked + $track": {
      backgroundColor: config.themeColor,
    },
  },
  checked: {},
  track: {},
})(Switch);

export default class VesselInsuranceAdd extends Component {
  constructor(props) {
    super(props);
    this.Cookie = new CookieHandler();
    this.state = {
      barge_id: null,
      insurance_level: "Vessel",
      business_no_id: "",
      voyage_type: "",
      vessel_type: "",
      barge_vessel_name: "",
      imo_no: "",
      year_built: "",
      flag: "",
      grt: "",
      classification: "",
      owners_p_and_i_cover: "",
      charterparty: "",
      delivery_date: null,
      estimated_duration: "",
      time_or_voyage: "",
      cargo: "",
      charterers_p_and_i_liability: "No",
      charterers_fd_and_d_liability: "No",
      back_to_back_sublet: "No",
      charterers_b_l: "No",
      contract_type: "Per Year",
      p_and_i_value: "",
      fd_and_d_value: "",
      currency: "0",
      exchange_rate: "",
      cost_to_company: 0,
      barges: [],
      other_expenses_data: [],
      activeStep: 0,
      files: [
        {
          file_description: "",
          file_name: "",
          file_extension: "",
          file_content: "",
          feature_name: "Insurance_and_declaration",
        },
      ],
      isLoading: true,
    };
  }

  async componentDidMount() {
    if (!this.Cookie.isLoggedIn()) {
      this.props.history.replace("/logout");
    }
    let features = this.Cookie.getCookie("features");
    this.setState({ features: features });
    if (!(features.includes("354")  || features.includes("97") )) {
      window.location.href = "/dashboard";
    }
    const loginUserID = this.Cookie.getCookie("loginUserId");
    const idToken = this.Cookie.getIdTokenCookie();
    var businessNoID = this.props.businessNo;
    if (businessNoID) {
      //Get businessNumber API based on businessNumber
      const getBusinessNumber = await api.getBusinessNumber(
        businessNoID,
        loginUserID,
        idToken
      );
      if (getBusinessNumber.status >= 200 && getBusinessNumber.status < 300) {
        getBusinessNumber.json().then((res) => {
          if (res.code === "200") {
            if (res.business_number) {
              this.setState({
                businessNo: res.business_number.business_no
                  ? res.business_number.business_no
                  : "",
                barge_vessel_name: res.business_number.mother_vessel_name
                  ? res.business_number.mother_vessel_name
                  : "",
                // isLoading: false
              });
            }
          } else if (res.code === "601") {
            this.setState({
              errorMsg: res.message,
              snackBarErrorOpen: true,
            });
          } else if (res.code === "607") {
            window.location.href = "/logout";
          }
        });
      }
    } else {
      this.setState({
        snackBarErrorOpen: true,
        errorMsg: "Invalid business number",
      });
    }
    // for get_Currencies
    const get_currencies = await api.getCurrencies(loginUserID, idToken);
    if (get_currencies.status >= 200 && get_currencies.status < 300) {
      get_currencies.json().then((res) => {
        if (res.idtoken) this.Cookie.setIdTokenCookie(res.idtoken);
        if (res.code === "200") {
          if (res.Currency) {
            var currencies = [
              <MenuItem value="0" key={-1} disabled>
                Select Currency
              </MenuItem>,
            ];
            for (var i of res.Currency) {
              currencies.push(
                <MenuItem value={i.currency} key={[i.id]}>
                  {i.currency}
                </MenuItem>
              );
            }
            this.setState({
              currencyData: currencies,
              isLoading: false,
            });
          } else {
            alert("Unexpected error occured. Please contact administrator.");
          }
        } else if (res.code === "601") {
          this.setState({
            snackBarErrorOpen: true,
            errorMsg: res.message,
          });
        } else if (res.code === "607") {
          window.location.href = "/logout";
        }
      });
    }
  }

  submitHandler = () => {
    const loginUserID = this.Cookie.getCookie("loginUserId");
    const idToken = this.Cookie.getIdTokenCookie();

    let {
      insurance_level,
      barge_id,
      voyage_type,
      vessel_type,
      barge_vessel_name,
      imo_no,
      year_built,
      flag,
      grt,
      classification,
      owners_p_and_i_cover,
      charterparty,
      delivery_date,
      estimated_duration,
      time_or_voyage,
      cargo,
      charterers_p_and_i_liability,
      charterers_fd_and_d_liability,
      back_to_back_sublet,
      charterers_b_l,
      contract_type,
      p_and_i_value,
      fd_and_d_value,
      currency,
      exchange_rate,
      cost_to_company,
      files,
    } = this.state;
    /**
     *  Checking Mandatory files
     */
    var missing_fields = 0;
    let files_missing = 0;
    var row = this.state.files;
    for (var obj of row) {
      if (obj.file_type !== "" || obj.file_content !== "") {
        if (obj.file_content !== "") {
          if (obj.file_description === "") {
            missing_fields++;
            obj.file_description_error = true;
          } else {
            obj.file_description = obj.file_description.toUpperCase();
          }
        } else if (obj.file_description !== "") {
          if (obj.file_content === "") {
            files_missing++;
          }
        }
      }
    }
    this.setState({
      files: row,
    });

    if (missing_fields > 0) {
      this.setState({
        snackBarErrorOpen: true,
        errorMsg: "Please fill mandatory fields.",
      });
      return;
    }
    if (files_missing > 0) {
      this.setState({
        snackBarErrorOpen: true,
        errorMsg: "Please Select file.",
      });
      return;
    }
    const content_files = files.filter((e) => e.file_content !== "");
    const business_no_id = this.props.businessNo;
    api
      .add_insurance_and_declaration(
        loginUserID,
        idToken,
        insurance_level,
        barge_id,
        business_no_id,
        voyage_type,
        vessel_type,
        barge_vessel_name,
        imo_no,
        year_built,
        flag,
        grt,
        classification,
        owners_p_and_i_cover,
        charterparty,
        delivery_date,
        estimated_duration,
        time_or_voyage,
        cargo,
        charterers_p_and_i_liability,
        charterers_fd_and_d_liability,
        back_to_back_sublet,
        charterers_b_l,
        contract_type,
        p_and_i_value,
        fd_and_d_value,
        currency,
        exchange_rate,
        cost_to_company,
        content_files
      )
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          response.json().then((res) => {
            if (res.code === "200") {
              this.setState(
                {
                  snackBarSuccessOpen: true,
                  successMsg: res.message,
                },
                () => {
                  this.props.onAddResponse(true);
                }
              );
            } else if (res.code === "601") {
              this.setState({
                snackBarErrorOpen: true,
                errorMsg: res.message,
              });
            } else if (res.code === "607") {
              window.location.href = "/logout";
            }
          });
        }
      });
  };

  toLocaleString(value) {
    return value ? Number(value).toLocaleString() : null;
  }

  insuranceCalculations = () => {
    let total =
      Number(this.state.p_and_i_value) + Number(this.state.fd_and_d_value);
    let currancy_exchg_rate = this.state.currency_exchg_rate
      ? this.state.currency_exchg_rate
      : 1;
    if (
      (config.company === "SDAM" ||
        config.company === "SRK" ||
        config.company === "BTR") &&
      this.state.currency === "IDR"
    ) {
      currancy_exchg_rate = 1;
    }
    if (
      (config.company === "SRPL" || config.company === "AVS"  || config.company === "PRPL") &&
      this.state.currency === "USD"
    ) {
      currancy_exchg_rate = 1;
    }
    let cost_to_company = (Number(total) * Number(currancy_exchg_rate)).toFixed(
      2
    );
    this.setState({
      cost_to_company: cost_to_company,
    });
  };

  render() {
    if (this.state.isLoading) {
      return <Loader />
    } else {
      return (
        <div className="container bg-white p-0" style={{ minHeight: "100vh" }}>
          <Snackbar
            anchorOrigin={{
              vertical: "top",
              horizontal: "center",
            }}
            open={this.state.snackBarErrorOpen}
            onClose={() => this.setState({ snackBarErrorOpen: false })}
            style={{ width: "450px" }}
          >
            <Alert
              elevation={6}
              variant="filled"
              onClose={() => this.setState({ snackBarErrorOpen: false })}
              severity="error"
              style={{ width: "100%" }}
            >
              {this.state.errorMsg}
            </Alert>
          </Snackbar>
          <Snackbar
            anchorOrigin={{
              vertical: "top",
              horizontal: "center",
            }}
            style={{ width: "450px" }}
            open={this.state.snackBarSuccessOpen}
            autoHideDuration={100000}
            onClose={() => this.setState({ snackBarSuccessOpen: false })}
          >
            <Alert
              elevation={6}
              variant="filled"
              onClose={() => this.setState({ snackBarSuccessOpen: false })}
              severity="success"
              style={{ width: "100%" }}
            >
              {this.state.successMsg}
            </Alert>
          </Snackbar>
          <div className="row">
            <div className="col-lg-12 p-0 border-bottom">
              <h6 style={{ padding: "15px", marginBottom: 0 }}>
                Insurance & Declaration
              </h6>
            </div>
          </div>

          <div className="drawer-section">
            <div className="card p-0">
              <div className="card-body">
                <div className="p-3 border_dashed  rounded-lg">
                  <div className="row mb-3">
                    <div className="col-lg-12 p-0">
                      <div className="row">
                        <div className="col-lg-6">
                          <label className="form_label mb-0">Vessel Type</label>
                          <TextField
                            name="voyage_type"
                            margin="dense"
                            variant="outlined"
                            inputProps={{
                              style: { textTransform: "uppercase" },
                            }}
                            value={this.state.voyage_type}
                            placeholder="Vessel Type"
                            fullWidth
                            onChange={(e) => {
                              this.setState({
                                voyage_type: e.target.value,
                              });
                            }}
                          />
                        </div>
                        <div className="col-lg-6">
                          <label className="form_label mb-0">Vessel Name</label>
                          <TextField
                            name="barge_vessel_name"
                            margin="dense"
                            variant="outlined"
                            inputProps={{
                              style: { textTransform: "uppercase" },
                            }}
                            value={this.state.barge_vessel_name}
                            placeholder="Vessel Name"
                            fullWidth
                            onChange={(e) => {
                              this.setState({
                                barge_vessel_name: e.target.value,
                              });
                            }}
                          />
                        </div>
                        <div className="col-lg-6">
                          <label className="form_label mb-0">IMO No</label>
                          <TextField
                            name="imo_no"
                            margin="dense"
                            variant="outlined"
                            inputProps={{
                              style: { textTransform: "uppercase" },
                            }}
                            value={this.state.imo_no}
                            placeholder="IMO No"
                            fullWidth
                            onChange={(e) => {
                              this.setState({
                                imo_no: e.target.value,
                              });
                            }}
                          />
                        </div>
                        <div className="col-lg-6">
                          <label className="form_label mb-0">Year Built</label>
                          <TextField
                            name="year_built"
                            margin="dense"
                            variant="outlined"
                            inputProps={{
                              style: { textTransform: "uppercase" },
                            }}
                            value={this.state.year_built}
                            placeholder="Year Built"
                            fullWidth
                            onChange={(e) => {
                              this.setState({
                                year_built: e.target.value,
                              });
                            }}
                          />
                        </div>
                        <div className="col-lg-6">
                          <label className="form_label mb-0">Flag</label>
                          <TextField
                            name="flag"
                            margin="dense"
                            variant="outlined"
                            inputProps={{
                              style: { textTransform: "uppercase" },
                            }}
                            value={this.state.flag}
                            placeholder="flag"
                            fullWidth
                            onChange={(e) => {
                              this.setState({
                                flag: e.target.value,
                              });
                            }}
                          />
                        </div>
                        <div className="col-lg-6">
                          <label className="form_label mb-0">Grt</label>
                          <TextField
                            name="grt"
                            margin="dense"
                            variant="outlined"
                            inputProps={{
                              style: { textTransform: "uppercase" },
                            }}
                            value={this.state.grt}
                            placeholder="grt"
                            fullWidth
                            onChange={(e) => {
                              this.setState({
                                grt: e.target.value,
                              });
                            }}
                          />
                        </div>
                        <div className="col-lg-6">
                          <label className="form_label mb-0">
                            Classification
                          </label>
                          <TextField
                            name="classification"
                            margin="dense"
                            variant="outlined"
                            inputProps={{
                              style: { textTransform: "uppercase" },
                            }}
                            value={this.state.classification}
                            placeholder="Classification"
                            fullWidth
                            onChange={(e) => {
                              this.setState({
                                classification: e.target.value,
                              });
                            }}
                          />
                        </div>
                        <div className="col-lg-6">
                          <label className="form_label mb-0">
                            Owners P&I Cover
                          </label>
                          <TextField
                            name="owners_p_and_i_cover"
                            margin="dense"
                            variant="outlined"
                            inputProps={{
                              style: { textTransform: "uppercase" },
                            }}
                            value={this.state.owners_p_and_i_cover}
                            placeholder="Owners P&I Cover"
                            fullWidth
                            onChange={(e) => {
                              this.setState({
                                owners_p_and_i_cover: e.target.value,
                              });
                            }}
                          />
                        </div>
                        <div className="col-lg-6">
                          <label className="form_label mb-0">
                            Charterparty
                          </label>
                          <TextField
                            name="charterparty"
                            margin="dense"
                            variant="outlined"
                            inputProps={{
                              style: { textTransform: "uppercase" },
                            }}
                            value={this.state.charterparty}
                            placeholder="Charterparty"
                            fullWidth
                            onChange={(e) => {
                              this.setState({
                                charterparty: e.target.value,
                              });
                            }}
                          />
                        </div>
                        <div className="col-lg-6">
                          <label className="form_label mb-0">
                            Delivery Date
                          </label>
                          <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <DatePicker
                              autoOk={true}
                              inputVariant="outlined"
                              variant="inline"
                              margin="dense"
                              fullWidth
                              format="dd/MM/yyyy"
                              value={this.state.delivery_date}
                              onChange={(date) => {
                                this.setState({
                                  delivery_date: date,
                                });
                              }}
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <IconButton>
                                      <EventIcon />
                                    </IconButton>
                                  </InputAdornment>
                                ),
                                className: "pl-0",
                              }}
                            />
                          </MuiPickersUtilsProvider>
                        </div>
                        <div className="col-lg-6">
                          <label className="form_label mb-0">
                            Estimated Duration
                          </label>
                          <TextField
                            name="estimated_duration"
                            margin="dense"
                            variant="outlined"
                            inputProps={{
                              style: { textTransform: "uppercase" },
                            }}
                            value={this.state.estimated_duration}
                            placeholder="Estimated Duration"
                            fullWidth
                            onChange={(e) => {
                              this.setState({
                                estimated_duration: e.target.value,
                              });
                            }}
                          />
                        </div>
                        <div className="col-lg-6">
                          <label className="form_label mb-0">Voyage</label>
                          <TextField
                            name="time_or_voyage"
                            margin="dense"
                            variant="outlined"
                            inputProps={{
                              style: { textTransform: "uppercase" },
                            }}
                            value={this.state.time_or_voyage}
                            placeholder="Voyage"
                            fullWidth
                            onChange={(e) => {
                              this.setState({
                                time_or_voyage: e.target.value,
                              });
                            }}
                          />
                        </div>
                        <div className="col-lg-6">
                          <label className="form_label mb-0">Cargo</label>
                          <TextField
                            name="cargo"
                            margin="dense"
                            variant="outlined"
                            inputProps={{
                              style: { textTransform: "uppercase" },
                            }}
                            value={this.state.cargo}
                            placeholder="Cargo"
                            fullWidth
                            onChange={(e) => {
                              this.setState({
                                cargo: e.target.value,
                              });
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row mb-3">
                    <div className="col-lg-6">
                      <label className="form_label mb-0">
                        Charterer's P&I Liability
                      </label>
                      <Typography component="div">
                        <Grid
                          component="label"
                          container
                          alignItems="center"
                          spacing={1}
                        >
                          <Grid item>No</Grid>
                          <Grid
                            item
                            style={{
                              position: "relative",
                              top: "3px",
                              paddingLeft: "20px",
                            }}
                          >
                            <FormControlLabel
                              control={
                                <PurpleSwitch
                                  checked={
                                    this.state.charterers_p_and_i_liability ===
                                    "Yes"
                                  }
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      this.setState({
                                        charterers_p_and_i_liability: "Yes",
                                      });
                                    } else {
                                      this.setState({
                                        charterers_p_and_i_liability: "No",
                                      });
                                    }
                                  }}
                                  name="checkedA"
                                />
                              }
                            />
                          </Grid>
                          <Grid item>Yes</Grid>
                        </Grid>
                      </Typography>
                    </div>
                    <div className="col-lg-6">
                      <label className="form_label mb-0">
                        Charterer's FD&D Liability
                      </label>
                      <Typography component="div">
                        <Grid
                          component="label"
                          container
                          alignItems="center"
                          spacing={1}
                        >
                          <Grid item>No</Grid>
                          <Grid
                            item
                            style={{
                              position: "relative",
                              top: "3px",
                              paddingLeft: "20px",
                            }}
                          >
                            <FormControlLabel
                              control={
                                <PurpleSwitch
                                  checked={
                                    this.state.charterers_fd_and_d_liability ===
                                    "Yes"
                                  }
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      this.setState({
                                        charterers_fd_and_d_liability: "Yes",
                                      });
                                    } else {
                                      this.setState({
                                        charterers_fd_and_d_liability: "No",
                                      });
                                    }
                                  }}
                                  name="checkedA"
                                />
                              }
                            />
                          </Grid>
                          <Grid item>Yes</Grid>
                        </Grid>
                      </Typography>
                    </div>
                    <div className="col-lg-6">
                      <label className="form_label mb-0">
                        Back to Back Sublet
                      </label>
                      <Typography component="div">
                        <Grid
                          component="label"
                          container
                          alignItems="center"
                          spacing={1}
                        >
                          <Grid item>No</Grid>
                          <Grid
                            item
                            style={{
                              position: "relative",
                              top: "3px",
                              paddingLeft: "20px",
                            }}
                          >
                            <FormControlLabel
                              control={
                                <PurpleSwitch
                                  checked={
                                    this.state.back_to_back_sublet === "Yes"
                                  }
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      this.setState({
                                        back_to_back_sublet: "Yes",
                                      });
                                    } else {
                                      this.setState({
                                        back_to_back_sublet: "No",
                                      });
                                    }
                                  }}
                                  name="checkedA"
                                />
                              }
                            />
                          </Grid>
                          <Grid item>Yes</Grid>
                        </Grid>
                      </Typography>
                    </div>
                    <div className="col-lg-6">
                      <label className="form_label mb-0">Charterer's B/L</label>
                      <Typography component="div">
                        <Grid
                          component="label"
                          container
                          alignItems="center"
                          spacing={1}
                        >
                          <Grid item>No</Grid>
                          <Grid
                            item
                            style={{
                              position: "relative",
                              top: "3px",
                              paddingLeft: "20px",
                            }}
                          >
                            <FormControlLabel
                              control={
                                <PurpleSwitch
                                  checked={this.state.charterers_b_l === "Yes"}
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      this.setState({
                                        charterers_b_l: "Yes",
                                      });
                                    } else {
                                      this.setState({
                                        charterers_b_l: "No",
                                      });
                                    }
                                  }}
                                  name="checkedA"
                                />
                              }
                            />
                          </Grid>
                          <Grid item>Yes</Grid>
                        </Grid>
                      </Typography>
                    </div>
                    <div className="col-lg-12">
                      <label className="form_label mb-0">Contract Type</label>
                      <Typography component="div">
                        <Grid
                          component="label"
                          container
                          alignItems="center"
                          spacing={1}
                        >
                          <Grid item>Per Year</Grid>
                          <Grid
                            item
                            style={{
                              position: "relative",
                              top: "3px",
                              paddingLeft: "20px",
                            }}
                          >
                            <FormControlLabel
                              control={
                                <PurpleSwitch
                                  checked={
                                    this.state.contract_type === "Per Vessel"
                                  }
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      this.setState({
                                        contract_type: "Per Vessel",
                                      });
                                    } else {
                                      this.setState({
                                        contract_type: "Per Year",
                                      });
                                    }
                                  }}
                                  name="checkedA"
                                />
                              }
                            />
                          </Grid>
                          <Grid item>Per Vessel</Grid>
                        </Grid>
                      </Typography>
                    </div>
                    {this.state.contract_type === "Per Vessel" && (
                      <div className="col-lg-6">
                        <label className="form_label mb-0">P&I Value</label>
                        <TextField
                          name="p_and_i_value"
                          margin="dense"
                          variant="outlined"
                          inputProps={{ style: { textTransform: "uppercase" } }}
                          value={this.state.p_and_i_value}
                          placeholder="Enter Value"
                          fullWidth
                          onChange={(e) => {
                            const pr = /^\d*(\.\d{0,4})?$/;
                            if (
                              e.target.value === "" ||
                              pr.test(e.target.value)
                            ) {
                              this.setState(
                                {
                                  p_and_i_value: e.target.value,
                                },
                                () => this.insuranceCalculations()
                              );
                            }
                          }}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment
                                position="end"
                                className="adornment_background"
                              >
                                USD
                              </InputAdornment>
                            ),
                            style: {
                              fontFamily: "Poppins",
                              fontSize: "14px",
                              padding: 0,
                            },
                          }}
                        />
                      </div>
                    )}
                    {this.state.contract_type === "Per Vessel" && (
                      <div className="col-lg-6">
                        <label className="form_label mb-0">FD&D Value</label>
                        <TextField
                          name="fd_and_d_value"
                          margin="dense"
                          variant="outlined"
                          inputProps={{ style: { textTransform: "uppercase" } }}
                          value={this.state.fd_and_d_value}
                          placeholder="Enter Value"
                          fullWidth
                          onChange={(e) => {
                            const pr = /^\d*(\.\d{0,4})?$/;
                            if (
                              e.target.value === "" ||
                              pr.test(e.target.value)
                            ) {
                              this.setState(
                                {
                                  fd_and_d_value: e.target.value,
                                },
                                () => this.insuranceCalculations()
                              );
                            }
                          }}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment
                                position="end"
                                className="adornment_background"
                              >
                                USD
                              </InputAdornment>
                            ),
                            style: {
                              fontFamily: "Poppins",
                              fontSize: "14px",
                              padding: 0,
                            },
                          }}
                        />
                      </div>
                    )}
                    {this.state.contract_type === "Per Vessel" && (
                      <div className="col-lg-6">
                        <label className="form_label mb-0">Currency</label>
                        <TextField
                          name="currency"
                          margin="dense"
                          variant="outlined"
                          fullWidth
                          select
                          InputProps={{
                            style: {
                              fontFamily: "Poppins",
                              fontSize: "14px",
                            },
                            disableUnderline: true,
                          }}
                          value={this.state.currency}
                          onChange={(e) => {
                            this.setState(
                              {
                                currency: e.target.value,
                              },
                              () => this.insuranceCalculations()
                            );
                          }}
                        >
                          {this.state.currencyData}
                        </TextField>
                      </div>
                    )}
                    {(config.company === "SDAM" ||
                      config.company === "SRK" ||
                      config.company === "BTR") &&
                      this.state.contract_type === "Per Vessel" &&
                      this.state.currency !== "IDR" &&
                      this.state.currency !== "0" && (
                        <div className="col-lg-6">
                          <label className="form_label mb-0">
                            Exchange Rate {this.state.currency} to IDR
                          </label>
                          <TextField
                            name="exchange_rate"
                            margin="dense"
                            variant="outlined"
                            inputProps={{
                              style: { textTransform: "uppercase" },
                            }}
                            value={this.state.exchange_rate}
                            placeholder="Enter Value"
                            fullWidth
                            onChange={(e) => {
                              const pr = /^\d*(\.\d{0,4})?$/;
                              if (
                                e.target.value === "" ||
                                pr.test(e.target.value)
                              ) {
                                var value = e.target.value;
                                if (value === null || value === "") {
                                  value = 1;
                                }
                                if (
                                  config.company === "SRPL" || config.company === "AVS"  ||
                                  config.company === "PRPL"
                                ) {
                                  value = 1 / Number(value);
                                }
                                this.setState(
                                  {
                                    exchange_rate: e.target.value,
                                    currency_exchg_rate: value,
                                  },
                                  () => this.insuranceCalculations()
                                );
                              }
                            }}
                          />
                        </div>
                      )}
                    {(config.company === "SRPL" || config.company === "AVS"  || config.company === "PRPL") &&
                      this.state.contract_type === "Per Vessel" &&
                      this.state.currency !== "USD" &&
                      this.state.currency !== "0" && (
                        <div className="col-lg-6">
                          <label className="form_label mb-0">
                            Exchange Rate USD to {this.state.currency}
                          </label>
                          <TextField
                            name="exchange_rate"
                            margin="dense"
                            variant="outlined"
                            inputProps={{
                              style: { textTransform: "uppercase" },
                            }}
                            value={this.state.exchange_rate}
                            placeholder="Enter Value"
                            fullWidth
                            onChange={(e) => {
                              const pr = /^\d*(\.\d{0,4})?$/;
                              if (
                                e.target.value === "" ||
                                pr.test(e.target.value)
                              ) {
                                var value = e.target.value;
                                if (value === null || value === "") {
                                  value = 1;
                                }
                                if (
                                  config.company === "SRPL" || config.company === "AVS"  ||
                                  config.company === "PRPL"
                                ) {
                                  value = 1 / Number(value);
                                }
                                this.setState(
                                  {
                                    exchange_rate: e.target.value,
                                    currency_exchg_rate: value,
                                  },
                                  () => this.insuranceCalculations()
                                );
                              }
                            }}
                          />
                        </div>
                      )}
                    {this.state.contract_type === "Per Vessel" && (
                      <div className="col-lg-6">
                        <label className="form_label mb-2">
                          Cost to Company
                        </label>
                        <div>
                          {this.state.cost_to_company
                            ? this.toLocaleString(this.state.cost_to_company)
                            : "-"}{" "}
                          {this.state.currency !== "0"
                            ? this.state.currency
                            : null}
                        </div>
                      </div>
                    )}
                  </div>
                  <hr />
                  {/* {(this.state.features.includes('363')  || this.state.features.includes('97') ) && */}

                  <FileUpload
                    files={this.state.files}
                    feature_name="Insurance_and_declaration"
                    callbackFn={(data) => this.setState({ files: data })}
                  />
                </div>
              </div>
            </div>
          </div>

          <footer className="row bottom_buttons_section">
            <button
              type="button"
              className="btn previous_button btn-light"
              name="submit"
              onClick={() => {
                this.props.returnCallbackDrawerClose(false);
              }}
            >
              Close
            </button>
            <button
              type="button"
              className="drawer_text drawer_btn_success"
              name="Back"
              onClick={this.submitHandler}
            >
              Submit
            </button>
          </footer>
        </div>
      );
    }
  }
}
